import request from '@/http/http'
const PREFIX='api/identity/organizations';

// 树形数据
export function getOrgAllTree(query){
  return request({
    url:PREFIX+'/all-tree',
    params: query 
  })
}
export function getOrgTree(query){
  return request({
    url:PREFIX+'/tree',
    params: query 
  })
}

// 非树形数据
export function getOrgAll(query){
  return request({
    url:PREFIX+'/all',
    params: query 
  })
}

// 非树形数据
export function getOrgs(query){
  return request({
    url:PREFIX,
    params: query 
  })
}

export function getByTagOrgs(query){
  return request({
    url:PREFIX+'/by-tag',
    params: query 
  })
}
// 非树形数据search
export function getOrgsSearch(query){
  return request({
    url:PREFIX+'/search',
    params: query 
  })
}
export function getOrgInfo(id){
  return request({
    url:PREFIX+'/'+id
  })
}

export function createOrg(data){
  return request({
    url:PREFIX,
    method:"post",
    data
  })
}

export function deleteOrg(id){
  return request({
    url:PREFIX+"/"+id,
    method:'delete'
  })  
}

export function updateOrg(id,data){
  return request({
    url:PREFIX+'/' + id,
    method:'put',
    data
  })
}

export function moveOrg(query){
  return request({
    url:PREFIX+'/move',
    params: query 
  })
}

export function getOrgRoles(id){
  return request({
    url:PREFIX+"/"+id+"/roles"
  })  
}

export function updateOrgRoles(id,data){
  return request({
    url:PREFIX+'/' + id+"/roles",
    method:'put',
    data
  })
}